<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
    	
		<el-dialog title="查看预警商品信息" :visible.sync="view" width="98%" top="2vh" :before-close="closedialog">
			<div class="purchase-warn-main">
				<div class="purchase-warn-left">
					<div class="purchase-warn-title">默认预警商品数量：</div>
					<div class="purchase-warn-value">
						<el-tooltip class="item" effect="dark" content="如商品没有设置采购预警库存数量时，将使用该默认预警数量" placement="top">
						<el-input type="text" size="small" v-model="warnnumber" @change="changewarnumber"/>
						</el-tooltip>
					</div>
					<div class="purchase-warn-message">注：请勿一次性选择超过20个预警商品到采购单中，否则有可能添加失败</div>

					<el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:20px">
						<el-form-item>
							<el-select v-model="query.brandid" clearable remote  filterable placeholder="按品牌" @change="query.ischange=true">	            
								<el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
									<span style="float: left">{{item.name}}</span>
									<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
								</el-option>              
							</el-select>          
						</el-form-item>
						<el-form-item>
							<el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getgoodlists" @change="query.ischange=true" style="width:100%"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" icon="el-icon-search" @click="getgoodlists">查询</el-button>
						</el-form-item>
					</el-form>
					<el-table ref="orderTable" :data="goodslists" style="width:100%" v-loading="query.loading" tooltip-effect="dark">
						<el-table-column label="id" width="100" align="center" fixed>
						    <template slot-scope="prop">
						        <div class="purchase-goods-id">{{prop.row.id}}</div>
								<div class="purchase-goods-number">{{prop.row.number}}</div>
						    </template>
						</el-table-column>
						<el-table-column label="商品信息" align="left" fixed>
						    <template slot-scope="prop">
						        <div class="purchase-goods-infos-s">
									<div class="purchase-goods-infos-thumb">
									<img :src="prop.row.thumb=='' ? require('../../../assets/img-default.png') : GLOBAL.staticUrl+prop.row.thumb" />
									</div>
									<div class="purchase-goods-infos-title">
										<div class="purchase-goods-infos-name">{{prop.row.name}}</div>
										<div class="purchase-goods-infos-code">条形码：{{prop.row.barcode}}</div>
										<i v-if="prop.row.brandname!=''">{{prop.row.brandname}}</i>
									</div>
								</div>
						    </template>
						</el-table-column>
						<el-table-column label="采购价（基本单位）" width="150" align="center">
						    <template slot-scope="prop">
						        <div class="purchase-goods-infos-value">{{prop.row.sell}}</div>
						    </template>
						</el-table-column>
						<el-table-column label="预警库存（基本单位）" width="150" align="center">
						    <template slot-scope="prop">
						        <div class="purchase-goods-infos-value">{{prop.row.warnumbers}}</div>
						    </template>
						</el-table-column>
						<el-table-column label="可用库存（基本单位）" width="150" align="center">
						    <template slot-scope="prop">
						        <div class="purchase-goods-infos-value">{{prop.row.lastinventorys}}</div>
						    </template>
						</el-table-column>
						<el-table-column label="操作" width="120" align="center" fixed="right">
						    <template slot-scope="prop">
						        <el-button size="mini" round :type="prop.row.isselect==true ? '' : 'warning' " @click="setselectgoods(prop.row)" >{{prop.row.isselect ? '取消商品' : '选择商品'}}</el-button>
						    </template>
						</el-table-column>
					</el-table>
					<div class="block">
					<!--分页begin-->
					<el-pagination
						@size-change="orderPageSizeChange"
						@current-change="orderPageCurrentChange"
						:current-page="query.p"
						:page-sizes="[10, 20, 50]"
						:page-size="query.rollpage"
						layout="total, sizes, prev, pager, next, jumper"
						:total="query.rows">
					</el-pagination>
					<!--分页end-->
					</div>
				</div>

				<!-- 已选中的商品 -->
				<div class="purchase-warn-rigth">
					<div class="purchase-warn-select-top">
						<div class="purchase-warn-select-gods">已选中：{{templists.length}} 个商品</div>
						<div class="purchase-warn-select-button">
							<el-button size="mini" round type="danger" @click="delallselectgoods">删除全部选中商品</el-button>
							<el-button size="mini" round type="warning" :disabled="templists.length==0 ? true : false " :loading="savegoodslists.loading" @click="savewarngoods" >添加到新增采购单</el-button>
						</div>
					</div>
					<div class="purchase-warn-select-goodslists">
						<div class="purchase-warn-select-goodslists-info" v-for="(item,index) in templists" :key="index">
							<div class="purchase-warn-select-goodslists-content">
								<div class="purchase-warn-select-goodslists-content-name">{{item.name}}</div>
								<div class="purchase-warn-select-goodslists-content-id">id：{{item.id}}</div>
							</div>
							<div class="purchase-warn-select-goodslists-nums"><el-input size="small" type="text" v-model="item.num" /></div>
							<div class="purchase-warn-select-goodslists-nums"><el-input size="small" type="text" v-model="item.unit" @focus="getunitlists(item,index)" /></div>
							<div class="purchase-warn-select-goodslists-del"><el-button type="danger" size="mini" icon="el-icon-delete" circle @click="deltempgoods(item,index)" /></div>
						</div>
					</div>
				</div>
			</div>
			
		</el-dialog>

		<el-dialog title="商品单位信息" :visible.sync="localunitDialog" width="35%" top="10vh">
			<el-table :data="unitlists" style="width:100%" v-loading="localunitloading" tooltip-effect="dark">
				<el-table-column label="单位" prop="unit" align="center" />
				<el-table-column label="进货价" prop="buy" width="150" align="center" />
				<el-table-column label="操作" width="120" align="center" fixed="right">
					<template slot-scope="prop">
						<el-button type="success" size="mini" circle icon="el-icon-check" @click="getunits(prop.row)" />
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

    	
    </div>
    </transition>       
</template>

<script>
export default {
	props: ["value"],
    data () {
	    return {
	        url:this.GLOBAL.domain+"Purchase/index",
	        transitionshow:true,
			view:false,
			warnnumber:'',
			query: {
				act:'getwarngoods',
				token:this.$cookies.get('token'),
				warnumber:'',
				brandid:'',
				key:'',
				p:1,
				rollpage:10,
				rows:0,
				loading:false,
				ischange:false,
			},
			goodslists:[],
			brandquery: {
				act:'lists',
				token:this.$cookies.get('token'),
				jdshow:0,
				rollpage:100000
			},
			brandlists:[],
			templists:[],
			savegoodslists: {
				act:'savewarngoodstopurchase',
				token:this.$cookies.get('token'),
				data:'',
				loading:false,
			},
			localunitindex:'',
			localunitDialog:false,
			localunitloading:false,
			unitlists:[],

	    }
    },

	watch: {
		value(val) {
			if(val) {
				this.view=true;
				this.resetparam();	   //重置参数
				this.templists=[];	   //清空选中的商品
				this.getwarnnumbers(); //获取默认采购预警库存数量
				this.getBrand();  	   //获取品牌信息
			}
		},

  	},
  
    mounted(){
    	
    },
  
    methods:{

		//保存商品预警商品信息
		savewarngoods() {
			if(this.templists.length==0) {this.$message.error('请选择要加入采购单的商品');return false;}
			this.$confirm('该操作将会先清空您已添加的采购单信息，是否继续 ？', '提示', { type: 'warning' }).then(() => {
        		
				var tempdata=[];
				this.templists.forEach(function(item,index) {tempdata.push({id:item.id,num:item.num,unitid:item.unitid,unit:item.unit,buy:item.sell})});
				tempdata=JSON.stringify(tempdata);
				this.savegoodslists.data=tempdata;
				this.savegoodslists.loading=true;
				var resource = this.$resource(this.url);
				resource.save(this.savegoodslists).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
						this.savegoodslists.loading=false;
					}else{
						this.savegoodslists.loading=false;

						//关闭当前窗口
						this.view=false;
						this.$emit('finish'); 

					}
				}).catch((res) => {
					this.savegoodslists.loading=false;
				});
				

	        }).catch(() => {
	            
	        });

		},

		//选择采购商品
		getunits(item) {
			this.localunitDialog=false;
			this.templists[this.localunitindex].unitid=item.id;
			this.templists[this.localunitindex].unit=item.unit;
		},


		//获取当前商品单位信息
		getunitlists(item,index) {
			this.localunitindex=index;
			this.localunitDialog=true;
			this.localunitloading=true;
			var resource = this.$resource(this.url);
			resource.save({act:'getunitlists',id:item.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.localunitloading=false;
				}else{
					this.unitlists = JSON.parse(Base64.decode(res.data.Data));
					this.localunitloading=false;
				}
			}).catch((res) => {
				this.localunitloading=false;	
			});

		},


		//选择、取消选择商品信息
		setselectgoods(item) {
			var ids=[];
			var number='';

			this.templists.forEach(function(e,index) {ids.push(e.id)});
			number=ids.indexOf(item.id);
			if(number >= 0) {
				this.$delete(this.templists,number);
			}else {
				this.templists.push({id:item.id,name:item.name,unitid:item.unitid,unit:item.unit,num:1,buy:item.sell});
			}
			item.isselect ? item.isselect=false : item.isselect=true;
			this.goodslists=JSON.parse(JSON.stringify(this.goodslists));
		},

		//删除选中商品信息
		deltempgoods(item,index) {
			this.goodslists.forEach(function(e,i) {
				if(item.id==e.id) e.isselect=false;
			});
			this.$delete(this.templists,index);
			this.goodslists=JSON.parse(JSON.stringify(this.goodslists));
		},

		//删除全部选中商品信息
		delallselectgoods() {
			this.$confirm('您是否确定删除全部已选中的商品信息 ？', '提示', { type: 'warning' }).then(() => {
        		this.templists=[];
				this.goodslists.forEach(function(e,i) {
					e.isselect=false;
				});
				this.goodslists=JSON.parse(JSON.stringify(this.goodslists));
	        }).catch(() => {
	            
	        });

		},


		//获取预警商品信息
		getgoodlists() {
			if(this.query.ischange) {
				this.query.p=1;
				this.query.rollpage=10;
			}
			
			this.query.loading=true;
			this.query.warnumber=this.warnnumber;
			var resource = this.$resource(this.url);
			resource.save(this.query).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.query.loading=false;
				}else{
					this.goodslists = JSON.parse(Base64.decode(res.data.Data));
					this.query.rows=parseInt(res.data.count);
					if(this.query.ischange) this.query.ischange=false;
					this.query.loading=false;

					//匹配勾选商品信息
					this.matchgoods();
				}
			}).catch((res) => {
				this.query.loading=false;
			});
		},

		orderPageSizeChange(val) {
        	this.query.rollpage = val;
        	this.getgoodlists();
	    },
	    orderPageCurrentChange(val) {
	        this.query.p = val;
	        this.getgoodlists();
	    },

		//匹配勾选的商品信息
		matchgoods() {
			var ids=[];
			this.templists.forEach(function(e,index) {ids.push(e.id)});
			this.goodslists.forEach(function(e,index) {
				ids.indexOf(e.id) >=0 ? e.isselect=true : e.isselect=false;
			});
		},



		//获取默认采购预警库存数量
		getwarnnumbers() {
			this.query.loading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
			resource.save({act:'getpurcharsenumber',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.warnnumber=result.purchasewarnumber;
					this.getgoodlists();   //获取预警商品信息
				}
			}).catch((res) => {
					
			});
		},


		//修改采购预警库存数量
		changewarnumber() {
			this.query.loading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
			resource.save({act:'setpurcharsenumber',numbers:this.warnnumber,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.resetparam();	   //重置参数
					this.getgoodlists();   //获取预警商品信息
				}
			}).catch((res) => {
					
			});
		},


		/** 获取品牌 **/
		getBrand(){
			var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
			resource.query(this.brandquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.brandlists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
			});
		},


		/** 重置参数 **/
		resetparam() {
			this.query.brandid='';
			this.query.key='';
			this.query.p=1;
			this.query.rollpage=10;
			this.query.rows=0;
			this.query.loading=false;
			this.query.ischange=false;
		},


	    //关闭当前窗口
		closedialog() {
			this.view=false;
			this.$emit('close');
		}

    }

}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.purchase-warn-main {display:inline-block;width:100%;}
.purchase-warn-left {float:left;width:65%;padding:0 2% 0 0;border-right:1px solid #ccc;}
.purchase-warn-title {display:inline-block;}
.purchase-warn-value {display:inline-block;width:10%;}
.purchase-goods-id {font-size:13px;color:#555555}
.purchase-goods-number {font-size:12px;color:#999999}
.purchase-goods-infos-s {display:inline-block;width:100%;}
.purchase-goods-infos-thumb {float:left;width:60px;height:60px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;display:flex;justify-content:center;align-items:center;}
.purchase-goods-infos-thumb img {max-width:100%;max-height:100%;}
.purchase-goods-infos-title {float:left;width:calc(100% - 67px);margin-left:5px;height:50px;}
.purchase-goods-infos-title i {float:left;font-size:12px;line-height:12px;padding:3px 10px;border-radius:15px;color:#fff;background:#67C23A;font-style:normal;margin-top:7px;}
.purchase-goods-infos-name {float:left;width:100%;font-size:13px;color:#555555;line-height:13px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-top:2px;}
.purchase-goods-infos-code {float:left;width:100%;font-size:12px;color:#999999;line-height:12px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-top:7px;}
.purchase-goods-infos-value {font-size:13px;color:#555555}
.purchase-warn-message {font-size:12px;color:#F56C6C;display:inline-block;margin-left:2%}

.purchase-warn-rigth {float:left;width:calc(100% - 67% - 1px - 2%);padding:0 0 0 2%;}
.purchase-warn-select-top {display:inline-block;width:100%}
.purchase-warn-select-gods {float:left;font-size:13px;color:#F56C6C;font-weight:500}
.purchase-warn-select-button {float:right}
.purchase-warn-select-goodslists {display:inline-block;width:100%;max-height:1000px;margin-top:20px;overflow-x:hidden;overflow-y:auto;}
.purchase-warn-select-goodslists::-webkit-scrollbar {width:0;height:0;}
.purchase-warn-select-goodslists::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.purchase-warn-select-goodslists::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}
.purchase-warn-select-goodslists-info {display:inline-block;width:100%;padding:15px 0;font-size:0;border-bottom:1px solid #ebeef5}
.purchase-warn-select-goodslists-content {float:left;width:50%;}
.purchase-warn-select-goodslists-content-name {float:left;width:100%;color:#555555;font-size:13px;line-height:13px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}
.purchase-warn-select-goodslists-content-id {float:left;width:100%;color:#999999;font-size:12px;line-height:12px;margin-top:10px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-style:italic;}
.purchase-warn-select-goodslists-nums {float:left;margin-left:5%;width:15%;}
.purchase-warn-select-goodslists-del {float:right;}
</style>


// WEBPACK FOOTER //
// src/components/purchase/warn/goods.vue